import { FC } from 'react';

import { useProcessedWorkStore } from '../../studentApp/hooks';
import { bannerStore } from '../../studentApp/stores';

import { Banner } from './banner/banner';
import { BottomBanner } from './banner/bottomBanner';
import { ExamButtons } from './banner/examButtons';
import { WelcomeStrip } from './banner/welcomeStrip';
import { SquaresAndProblem } from './squares/squaresAndProblem';

export const LandscapeLayout: FC = () => {
  const { isTesting } = useProcessedWorkStore();
  const [hideWelcomeStrip, setHideWelcomeStrip] = bannerStore(state => [
    state.hideWelcomeStrip,
    state.setHideWelcomeStrip,
  ]);

  const welcomeCloser = () => setHideWelcomeStrip(true);

  return (
    <>
      {!hideWelcomeStrip && <WelcomeStrip closer={welcomeCloser} />}
      <Banner />
      {isTesting && <ExamButtons />}
      <SquaresAndProblem />
      <BottomBanner />
    </>
  );
};
